import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ach-pay-tc',
  templateUrl: './ach-pay-tc.component.html',
  styleUrls: ['./ach-pay-tc.component.scss']
})
export class AchPayTcComponent {
  @Input() merchantName: string;
  @Input() contactNumber: string;
  @Input() isAgreed: boolean;

  constructor(private activeModal: NgbActiveModal) { }

  close(data?: any) {
    this.activeModal.close(data);
  }

  onAgree(isAgree: boolean = false): void {
    this.close(this.isAgreed || isAgree);
  }
}
